import * as defaultImport from "@splunk/visualizations/Table";
export * from "@splunk/visualizations/Table";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
